import Request from '../util/dfs-request'

const path = "eip-mapp-dfs-server/"
const ddpath = "dd-api/"

export function saveFileSuffix() {
  return Request({
    url: path + 'fileEnclosure/saveFileSuffix',
    method: 'post',
    data: {
      type: 'get',
    }
  })
}

export function upload(serverName, categoryName, identification, file, cd) {
  let formdata = new FormData();
  formdata.append('file', file);
  return Request({
    url: path + 'fileEnclosure/file?serverName=' + serverName + "&categoryName=" + categoryName + "&identification=" + identification,
    method: 'post',
    data: formdata,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: function (progressEvent) {
      if (progressEvent.lengthComputable) {
        cd && cd(progressEvent);
      }
    },
  })
}
/**文亮文件从中转站转成http供前端下载接口 */
export function getFileUrl(params) {
  return Request({
    responseType: 'blob',
    url: path + 'copy/download/?filePath=' + params,
    method: 'get',
    // data: params
  })
}

export function deleteFile(data) {
  return Request({
    url: path + 'copy/clearFile',
    method: 'post',
    data
  })
}

export function copyUpload(serverName, categoryName, identification, file, cd) {
  let formdata = new FormData();
  formdata.append('file', file);
  return Request({
    url: path + 'copy/upload?serverName=' + serverName + "&categoryName=" + categoryName + "&identification=" + identification,
    method: 'post',
    data: formdata,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: function (progressEvent) {
      if (progressEvent.lengthComputable) {
        cd && cd(progressEvent);
      }
    },
  })
}

export function newUpload(serverName, categoryName, identification, file, cd) {
  let formdata = new FormData();
  formdata.append('file', file);
  return Request({
    url: path + 'copy/nowUploadFile?serverName=' + serverName + "&categoryName=" + categoryName + "&identification=" + identification,
    method: 'post',
    data: formdata,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: function (progressEvent) {
      if (progressEvent.lengthComputable) {
        cd && cd(progressEvent);
      }
    },
  })
}

export function newDeleteFile(data) {
  return Request({
    url: path + 'copy/deleteFile',
    method: 'post',
    data
  })
}

export function getFile(serverName, categoryName, identification) {
  return Request({
    url: path + 'fileEnclosure/file?serverName=' + serverName + "&categoryName=" + categoryName + "&identification=" + identification,
    method: 'get',
  })
}

export function previewFile(data) {
  return Request({
    url: path + 'fileApi/previewOAFile?serverName=eip-mapp-oa-server&fileId=' + data,
    method: 'get',
  })
}

export function getNWFile(serverName, categoryName, identification) {
  return Request({
    url: path + 'fileEnclosure/queryfiles?serverName=' + serverName + "&categoryName=" + categoryName + "&identification=" + identification,
    method: 'get',
  })
}

export function updateFileState(data) {
  return Request({
    url: path + 'fileEnclosure/batchUpdateFileStatus',
    method: 'post',
    data: data
  })
}
